// ============================================================================
// ORDERS · Collection — what changing the line resets (pure, no imports)
// ============================================================================
// ONE rule, two callers: the Wall's Sun | Optic switch (useCollectionLine) and
// Home's "Collection · Sun / Optic" destinations (CLB-069, Stage 4). No imports on
// purpose — Home's navigation model and its node tests load this file without
// the Supabase client. `st` is the Orders UI store's state (its setters).
//   · the line is the store's bookKind (the address's &book=optic);
//   · the Book's sub-collection resets with it (the Book's own setter does too);
//   · the open drawer and every facet / deck pick belong to a line — they reset.
// ============================================================================
const lineName = (line) => (line === 'optic' ? 'optic' : 'sun');

/** The Collection slice's per-line state — what a line change drops. */
export const COLLECTION_LINE_RESET = { model: null, facets: {}, rfacets: {}, fam: '', mats: [], subs: [] };

/** Switch the line; returns false (and writes nothing) when it is already the open one. */
export function resetCollectionForLine(st, next) {
  const to = lineName(next);
  if (lineName(st.bookKind) === to) return false;
  st.setBookKind(to);
  st.setBookSub('all');
  st.setCollection({ ...COLLECTION_LINE_RESET });
  return true;
}

/**
 * Open the plain Wall on a line: the line, the Wall view, and a clean slate
 * (no search, no kind switch, no "not ordered yet", no stale drawer, no deck
 * picks). The person's remembered group / sort / density stay — they are
 * preferences, not a place.
 */
export function openCollectionWall(st, line) {
  st.setBookKind(lineName(line));
  st.setBookSub('all');
  st.setCollection({ ...COLLECTION_LINE_RESET, view: 'wall', q: '', kind: 'all', nyo: false });
}
